import { NgModule } from '@angular/core';

import { BrandComponent } from "./brand.component";

@NgModule({
    imports: [],
    declarations: [
        BrandComponent
    ],
    exports: [
        BrandComponent
    ]
})
export class BrandModule { }


// WEBPACK FOOTER //
// ./src/app/public/brand/brand.module.ts